import { Routes } from '@angular/router';
import { staffGuard } from './core/guards/staff.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

const TITLE = 'Kalaburagi Sports Habba';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    title: TITLE,
  },
  {
    path: 'matches',
    loadComponent: () => import('./features/matches/matches.component').then(m => m.MatchesComponent),
    title: `Matches · ${TITLE}`,
  },
  {
    path: 'live',
    loadComponent: () => import('./features/live/live.component').then(m => m.LiveComponent),
    title: `Live · ${TITLE}`,
  },
  {
    path: 'gallery',
    loadComponent: () => import('./features/gallery/gallery.component').then(m => m.GalleryComponent),
    title: `Gallery · ${TITLE}`,
  },
  {
    path: 'staff/login',
    loadComponent: () => import('./features/staff-login/staff-login.component').then(m => m.StaffLoginComponent),
    title: `Staff Login · ${TITLE}`,
  },
  {
    path: 'staff/dashboard',
    loadComponent: () => import('./features/staff-dashboard/staff-dashboard.component').then(m => m.StaffDashboardComponent),
    canActivate: [staffGuard],
    canDeactivate: [unsavedChangesGuard],
    title: `Staff Panel · ${TITLE}`,
  },

  // Old IA: fixtures and results are one page now, and the cyclathon is a
  // sport tab on it rather than a page of its own.
  { path: 'fixtures', redirectTo: 'matches' },
  { path: 'results', redirectTo: 'matches' },
  { path: 'cyclathon', redirectTo: 'matches?sport=cyclathon' },
  { path: '**', redirectTo: '' },
];
